import './Preloader.css'

const Preloader = ({preloaderText}) => {
  return (
    <div className="loader-container">
      <p className='preloader-title'>{preloaderText}</p>
      <span class="loader"></span>
    </div>
  );
};

export default Preloader;